import { toast } from 'react-toastify';
import Api from '../../Components/Api';
import mergn from 'mergn-webapp-sdk'
import { STORE_LIST, CITIES_WEB, PICKUP_STORES_LIST, DELIVERY_STORES_LIST, SELECT_STORE_ID, SELECT_STORE, GET_TAX_CASH, GET_TAX_CARD, ACTIVE_STORE, UPDATE_ONLINE_DEL_FEE, SAVE_POS_FEE } from "./storeTypes"
var CryptoJS = require("crypto-js");

export const getStores = () => {
  return async (dispatch: any) => {
    Api.get(`customer/stores`)
      .then((response: any) => {
        if (response.data.success) {
          dispatch({
            type: STORE_LIST,
            payload: response.data.successResponse
          })
        }
      })
      .catch((err: any) => {

        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          toast.error(error, {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
          });
        } else {
        }
      });

  };
};

export const getCitiesWeb = () => {
  return function (dispatch: any) {
    Api.get(`/customer/cities_web`)
      .then((response) => {
        if (response.data.success) {
          let ResponseData: any = response.data.successResponse;
          ResponseData.map((city: any) => {
            city.value = city.id;
            city.label = city.name;
          })

          dispatch({
            type: CITIES_WEB,
            payload: ResponseData
          })
        }
      }).catch(err => {
        if (err.response) {

        } else {
          alert(err.message)
        }
      });
  }
}


function calculateDistance(lat1: any, lon1: any, lat2: any, lon2: any) {
  const earthRadius = 6371; // Radius of the Earth in kilometers
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = earthRadius * c; // Distance in kilometers
  return distance;
}

function toRadians(degrees: any) {
  return (degrees * Math.PI) / 180;
}
export const findPickupStores = (setState?: any) => {
  return async (dispatch: any) => {
    Api.get("menu/stores")
      .then((response) => {
        if (response.data.success) {
          let data: any = [];
          let Responedata = response.data.successResponse;
          let activeStores: any = [];
          let userLat: any = sessionStorage.getItem('lat');
          let userLng: any = sessionStorage.getItem('lng');
          const d = new Date();
          let currentDayIndex = d.getDay();
          let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          let dayName = days[currentDayIndex];
          if (userLat || userLng) {
            const R = 6371;
            Responedata.map((store: any) => {
              let isPickupChannel = false;
              store.channel_timing_id.map((channel: any) => {
                if (channel.channel_id.sales_channel_id == 2) {
                  isPickupChannel = true;
                  if (store?.is_channel_timing && channel?.store_open_time && channel?.store_open_time) {
                    store.store_open_time = channel?.store_open_time
                    store.store_close_time = channel?.store_close_time
                  }
                  if (store.isDays == 1 && store.channel_days_timing) {
                    let weekDaysTimingArr = JSON.parse(store.channel_days_timing)
                    let storeOpenTime = null;
                    let storeCloseTime = null;
                    weekDaysTimingArr.map((storeDay: any) => {
                      if (dayName == storeDay.day) {
                        let timePeriods = storeDay.timePeriods;
                        timePeriods.map((period: any) => {
                          if (period.channel == channel.channel_id.channel_name) {
                            storeOpenTime = period.opening;
                            storeCloseTime = period.closing;
                          }
                        })
                      }
                    })
                    store.store_open_time = storeOpenTime
                    store.store_close_time = storeCloseTime
                  }
                  if (store.is_active && store.is_snooze == 0)
                    store.channel_active = channel?.store_active;
                  else store.channel_active = 0;
                }
              });
              if (store.trade_zone_id.is_active == 1 && isPickupChannel) {
                let distance = calculateDistance(store.lat, store.lng, userLat, userLng)
                store.distance = distance.toFixed(0);
                activeStores.push(store)
              }
            });
            activeStores.sort((a: any, b: any) => a.distance - b.distance);
            dispatch({
              type: PICKUP_STORES_LIST,
              payload: activeStores
            })
            setTimeout(() => {
              setState(true);
            }, 500)
          }
          else {
            Responedata.map((store: any) => {
              let isPickupChannel = false;
              store.channel_timing_id.map((channel: any) => {
                if (channel.channel_id.channel_name === "pickup") {
                  isPickupChannel = true;
                  if (
                    store?.is_channel_timing &&
                    channel?.store_open_time &&
                    channel?.store_open_time
                  ) {
                    store.store_open_time = channel?.store_open_time;
                    store.store_close_time = channel?.store_close_time;
                  }
                  if (store.isDays == 1 && store.channel_days_timing) {
                    let weekDaysTimingArr = JSON.parse(store.channel_days_timing)
                    let storeOpenTime = null;
                    let storeCloseTime = null;
                    weekDaysTimingArr.map((storeDay: any) => {
                      if (dayName == storeDay.day) {
                        let timePeriods = storeDay.timePeriods;
                        timePeriods.map((period: any) => {
                          if (period.channel == channel.channel_id.channel_name) {
                            storeOpenTime = period.opening;
                            storeCloseTime = period.closing;
                          }
                        })
                      }
                    })
                    store.store_open_time = storeOpenTime
                    store.store_close_time = storeCloseTime
                  }
                  if (store.is_active && store.is_snooze == 0)
                    store.channel_active = channel?.store_active;
                  else store.channel_active = 0;
                }
              });
              if (store.trade_zone_id.is_active == 1 && isPickupChannel) {
                activeStores.push(store)
              }
            }

            );
            dispatch({
              type: PICKUP_STORES_LIST,
              payload: activeStores
            })
            setTimeout(() => {
              setState(true);
            }, 500)
          }

        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          let data: any = [];
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          dispatch({
            type: "PICKUP_STORES_LIST",
            payload: []
          });
        } else {
          alert("Connection Lost")
        }
      });
  };
};
//For Delivery

export const getDeliveryStores = () => {
  return async (dispatch: any) => {
    Api.get("menu/stores")
      .then((response) => {
        if (response.data.success) {
          let Responedata = response.data.successResponse;
          let activeStores: any = [];
          Responedata.map((store: any) => {
            store.channel_timing_id.map((channel: any) => {
              if (channel.channel_id.sales_channel_id == 1) {
                if (store?.is_channel_timing && channel?.store_open_time && channel?.store_open_time) {
                  store.store_open_time = channel?.store_open_time
                  store.store_close_time = channel?.store_close_time
                }
                if (store.is_active && store.is_snooze == 0)
                  store.channel_active = channel?.store_active;
                else store.channel_active = 0;
                activeStores.push(store);
              }

            });
          })
          dispatch({
            type: DELIVERY_STORES_LIST,
            payload: activeStores
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          toast.error(error, {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
          });
          dispatch({
            type: DELIVERY_STORES_LIST,
            payload: []
          });
        } else {
          alert("Connection Lost");
        }
      });
  };
};

export const saveSelectStoreId = (store: any) => {
  return function (dispatch: any) {
    dispatch(saveStore(store));
    dispatch({
      type: SELECT_STORE_ID,
      selectStoreId: store.store_id,
      pos_fee: store.state_id.pos_service_fee ? store.state_id.pos_service_fee : 0
    });
    dispatch(saveTaxDetails(store.state_id.state_name))
    mergn.recordEvent('Start Your Order', [
      { eventProperty: 'city-name', value: store?.city ?? '' },
    ]);
    mergn.recordAttribute('City', store?.city ?? '');
    mergn.recordAttribute('Branch', store?.store_name ?? '')
  };
};
export const saveStore = (store: any) => {
  return function (dispatch: any) {
    dispatch({
      type: SELECT_STORE,
      storeSelected: store,
    });
  };
};

export const saveTaxDetails = (state_name: any) => {
  return function (dispatch: any) {
    Api.get(`menu/tax/${state_name}`)
      .then((response) => {
        if (response.data.success) {

          let responseData = response.data.successResponse
          responseData.map((taxVariations: any) => {
            if (taxVariations.payment_method == 'cash') {
              dispatch({
                type: GET_TAX_CASH,
                payload: taxVariations,
                deliveryfee: taxVariations.delivery_fee,
                pos_fee: taxVariations.pos_service_fee
              });
            }
            else if (taxVariations.payment_method == 'card') {
              dispatch({
                type: GET_TAX_CARD,
                payload: taxVariations,
                deliveryfee: taxVariations.delivery_fee,
                pos_fee: taxVariations.pos_service_fee
              });

            }
          })
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_TAX_CASH,
          payload: null,
          deliveryfee: 50
        });
        dispatch({
          type: GET_TAX_CARD,
          payload: null,
          deliveryfee: 50
        });
      });
  }
}

export const updateOnlineDeliveryFee = (deliveryfee: any) => {
  return function (dispatch: any) {
    dispatch({
      type: UPDATE_ONLINE_DEL_FEE,
      deliveryfee: deliveryfee
    });
  }
}

export const saveStorePosFee = (fee: any) => {
  return function (dispatch: any) {
    dispatch({
      type: SAVE_POS_FEE,
      payload: fee
    })
  }
}

export const getTimezone = (id: number) => {
  return function (dispatch: any) {
    return Api.get(`/customer/state/timezone/${id}`)
      .then((response) => {
        if (response.data.success) {
          return response.data.successResponse
        }
      }).catch(err => {
        if (err.message) {
          alert(err.message)
        }
      });
  }
}

export const getTimezoneForLater = (id: number) => {
  return function (dispatch: any) {
    return Api.get(`/customer/state/timezone/${id}`)
      .then((response) => {
        if (response.data.success) {
          return { time: response.data.successResponse, date: response.data.successLaterResponse }
        }
      }).catch(err => {
        if (err.message) {
          alert(err.message)
        }
      });
  }
}

export const checkStoreActive = (store_id: any, orderType: any) => {
  return async (dispatch: any) => {
    Api.get(`customer/store/${store_id}`)
      .then((response: any) => {
        if (response.data.success) {
          if (response.data.successResponse.is_snooze == 0) {
            let storeActive = true;
            response.data.successResponse.channel_timing_id.map((channel: any) => {
              if (orderType == "Pickup" && channel.channel_id.sales_channel_id == 2 && channel?.store_active == 0) {
                storeActive = false;
              } else if (orderType == "Delivery" && channel.channel_id.sales_channel_id == 1 && channel?.store_active == 0) {
                storeActive = false;
              }
            });
            if (storeActive) {
              dispatch({
                type: ACTIVE_STORE,
                payload: response.data.successResponse
              })
            } else {
              dispatch({
                type: ACTIVE_STORE,
                payload: null
              })
            }
          } else {
            dispatch({
              type: ACTIVE_STORE,
              payload: null
            })
          }
        }
      })
      .catch((err: any) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          dispatch({
            type: ACTIVE_STORE,
            payload: null
          })
        } else {
        }
      });
  };
};

export const updatedKmlStore = (store_id: any, position: any, orderType: any, tax_percent: any, pos_fee: any, delivery_fee: any) => {
  return async (dispatch: any) => {
    let body = {
      lat: position?.lat,
      long: position?.lng,
      store_id: store_id,
      orderType: orderType,
      tax_percent: tax_percent,
      pos_fee: pos_fee,
      delivery_fee: delivery_fee
    }
    var logs = CryptoJS.AES.encrypt(JSON.stringify(body), process.env.REACT_APP_EncryptionKey).toString();
    Api.post(`customer/get_updated_zone`, { body: logs })
      .then((response: any) => {
        if (response.data.success) {
          const resData = response.data?.successResponse[0]
          if(resData) {
            if(resData.tax_update || store_id !== resData.store_id) {
              dispatch(saveStore(resData));
              dispatch({
                type: SELECT_STORE_ID,
                selectStoreId: resData.store_id
              });
              dispatch(saveTaxDetails(resData.state_id.state_name))
              dispatch(saveStorePosFee(resData.pos_service_fee))
            }
            else {
              if(resData) {
                if(resData.pos_service_fee !== pos_fee) {
                  dispatch(saveStorePosFee(resData.pos_service_fee))
                }
                if(resData.state_id.delivery_fee !== delivery_fee) {
                  dispatch(updateOnlineDeliveryFee(resData.state_id.delivery_fee))
                }
              }
            }
          }
        }
      })
      .catch((err: any) => {
        if (err.response) {
          toast.error(`We do not deliver on your current location. Please select different location for delivery or go for pick up. You can also just browse the menu.`, {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
          });
          dispatch({
            type: SELECT_STORE,
            storeSelected: null,
          });
        } else {
        }
      });
  };
};